<template>
  <div class="captain-wrapper">
    <div class="captain" ref="captain">
      <div class="distress-message">
        Captain we seem to have hit some kind of energy distortion!!!
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
export default {
  name: "captain",
  props: {
    zoom: Number
  },
  data() {
    return {
      tl: null,
      tlplayed: 0
    };
  },
  mounted() {
    this.initAnim();
  },
  methods: {
    initAnim() {
      let captain = this.$refs.captain;
      this.tl = gsap.timeline({ paused: true});
      this.tl.set(captain,{alpha: 1})

      this.tl.fromTo(
        captain,
        {
          duration: 8,
          transformOrigin: "50% 50%",
          rotation: -360,
          scale: 0.01,
          ease: "Power4.easeIn"
        },

        {
          rotation: 360,
          scale: 1
        }
      );
      this.tl.to(captain, 4, {
        scaleX: 2,
        skewX: "50deg"
      });
      this.tl.to(
        captain,
        1,
        {
          scaleY: 3
        },
        "<"
      );
      this.tl.to(captain, 4, {
        scaleY: 30,
        alpha: 0
      });

    }
  },
  watch: {
    zoom(nv) {
      if (nv >= 96) {
        this.tl.play();
      } else {
        if (!this.tl.reversed() && !this.tl.paused()) {
          this.tl.reverse(0.4);
        }
      }
    }
  }
};
</script>

<style lang="scss">
.captain-wrapper {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.captain {
  max-width: 60%;
  opacity: 0;
}
.distress-message {
  font-size: 60px;
  font-weight: 800;
  line-height: 1;
  color: #e67be6;
  mix-blend-mode: overlay;
}
</style>
